<template>
  <div class="container_box" id="video_box">
    <div class="van_swipe">
      <!--vant van-swipe 滑动组件 -->
      <van-swipe
        :show-indicators="false"
        @change="onChange"
        vertical
        :loop="false"
        :initial-swipe="current"
      >
        <van-swipe-item
          v-for="(item, index) in videoList"
          :key="index"
          class="product_swiper"
        >
          <div class="video_container">
            <!--video属性
                    webkit-playsinline ios 小窗播放，使视频不脱离文本流，安卓则无效
                    微信内置x5内核，
                    x5-video-player-type="h5-page" 启用H5播放器,是wechat安卓版特性，添加此属性，微信浏览器会自动将视频置为全屏
                    x5-video-player-fullscreen="true" 全屏设置，设置为 true 是防止横屏
                    x5-video-orientation 控制横竖屏 landscape 横屏，portrain竖屏； 默认portrain
                    poster：封面
                    src：播放地址
            -->
            <video
              class="video_box"
              loop
              webkit-playsinline="true"
              x5-video-player-type="h5-page"
              x5-video-player-fullscreen="true"
              playsinline
              preload="auto"
              :poster="item.video_cover"
              :src="item.video_link"
              :playOrPause="playOrPause"
              @click="pauseVideo"
              @ended="onPlayerEnded($event)"
            ></video>
            <!-- 封面 -->
            <img
              v-show="isVideoShow"
              class="play"
              @click="playvideo"
              :src="item.cover"
            />
            <!-- 播放暂停按钮 -->
            <img
              v-show="iconPlayShow"
              class="icon_play"
              @click="playvideo"
              src="http://npjy.oss-cn-beijing.aliyuncs.com/images/file-1575340653940esdHR.png"
            />
          </div>
          <!-- 右侧头像、点赞、评论、分享功能 -->
          <div class="tools_right">
            <div class="tools_r_li">
              <img :src="item.ShareUserInfo.avatar" class="tag_image" />
              <i
                class="iconfont icon-jiahao tag_add"
                @click="checkSubscribe(item.ShareUserInfo.uid)"
              ></i>
            </div>
            <div class="tools_r_li" @click="backindex">
              <img
                src="https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/yz_iconm.png"
                style="display: block;width: .5rem;"
              />
              <div class="tools_r_num">
                更多视频
              </div>
            </div>
          </div>
          <!-- 底部作品描述 -->
          <div class="production_box">
            <div class="production_name">{{ item.video_name }}</div>
          </div>
          <!--底部操作栏-->
          <div class="footer_gg">
            <!-- //存在广告 -->
            <div class="addimg" v-if="JSON.stringify(item.ad_info).length > 5">
              <div class="addimgs">
                <img :src="item.ad_info.ad_image" />
              </div>
              <div class="gg_text">
                <div class="gg_textTitle">{{ item.ad_info.ad_name }}</div>
                <div class="gg_textDec">
                  {{ item.ad_info.ad_describe }}
                </div>
              </div>
            </div>
            <!-- 不存在广告 -->
            <div class="addimg" v-if="JSON.stringify(item.ad_info).length < 5">
              <div class="addimgs">
                <img :src="item.ShareUserInfo.avatar" />
              </div>
              <div class="gg_text">
                <div class="gg_textTitle">
                  {{ item.ShareUserInfo.nickname }}
                </div>
                <div class="gg_textDec">
                  {{ item.ShareUserInfo.personality }}
                </div>
              </div>
            </div>
          </div>
        </van-swipe-item>
      </van-swipe>
      <div class="bianchengmy" @click="bianchengmy">变成我的视频</div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { Swipe, SwipeItem, Toast } from "vant";
import {
  getShare,
  getVideoListNew,
  getVideoDetailsNew,
  getVideoCollectAddNew,
  getVideoCollectDelNew
} from "@api/public";
import { cookie } from "@utils/store/cookie";
import { openShareAll, wxShowLocation } from "@libs/wechat";
import { isWeixin } from "@utils/index";
// 引入微信分享
import wx from "weixin-js-sdk";
Vue.use(Swipe, Toast).use(SwipeItem);
let sourceData = [];
let videoProcessInterval;
export default {
  name: "videshareindex",
  data() {
    let u = navigator.userAgent;
    return {
      ShareUserInfo: {},
      video_id: "",
      urlKey: "", //接收分享的key
      current: 0,
      shareTishi: false,
      videoList: [],
      isVideoShow: true,
      playOrPause: true,
      video: null,
      iconPlayShow: true,
      isAndroid: u.indexOf("Android") > -1 || u.indexOf("Adr") > -1, // android终端
      isiOS: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), // ios终端
      tabIndex: 0,
      showShareBox: false, //展示分享框
      commentPop: false, //是否展示评论弹框
      // 评论相关
      comment_text: "", //评论输入内容
      canSend: false, //是否可以发送
      videoComment: [],
      commentPlaceholder: "留下你精彩的评论吧", //评论Placeholder
      replayUserData: "",
      to_comment_id: "",
      videoProcess: 0, //视频播放进度
      page: 1,
      videolistOld: []
    };
  },
  mounted() {
    this.video_id = this.$route.query.id;
    this.urlKey = this.$route.query.secret_key; //存储数据，表示用户是从分享链接进入的
    this.getVideoDetailsNew();
    //获取到视频资源后默认自动播放
    setTimeout(() => {
      this.playvideo();
    }, 500);
  },
  methods: {
    // 初始获取相应的视频详情
    getVideoDetailsNew() {
      var data = "?video_id=" + this.video_id + "&key=" + this.urlKey;
      getVideoDetailsNew(data).then(res => {
        var cont = {
          video_name: res.data.video_name,
          video_cover: res.data.video_cover
        };
        this.setOpenShare(cont);
        this.videoList.push(res.data);
      });
    },
    //查看该作者
    checkSubscribe(id) {
      window.location.href = "/jiaodian/userWeizhan?uid=" + id;
    },
    //更多视频
    backindex() {
      window.location.href = "/?id=1";
    },

    //滑动改变播放的视频
    onChange(index) {
      //改变的时候 暂停当前播放的视频
      clearInterval(videoProcessInterval);
      this.videoProcess = 0;
      let video = document.querySelectorAll("video")[this.current];
      video.pause();
      this.playOrPause = false;
      this.showShareBox = false;
      this.current = index; //当前播放第几个
      //非ios切换直接自动播放下一个
      this.pauseVideo();
      console.log(index);
      var cont = {
        video_name: this.videoList[index].video_name,
        id: this.videoList[index].id,
        secret_key: this.videoList[index].secret_key,
        video_cover: this.videoList[index].video_cover
      };
      this.setOpenShare(cont);
    },
    // 开始播放
    playvideo(event) {
      let video = document.querySelectorAll("video")[this.current];
      console.log("playvideo：" + this.current);
      this.isVideoShow = false;
      this.iconPlayShow = false;
      this.showShareBox = false;
      video.play();

      if (this.isiOS) {
        setTimeout(() => {
          //处理ios宽视频
          let documentW =
            document.documentElement.clientWidth || document.body.clientWidth;
          let docB = parseFloat(video.videoWidth / documentW);
          console.log("获取视频宽和屏幕比：" + docB);
          // 计算视频最适高度
          let realH = parseInt(video.videoHeight / docB);
          this.realH = realH + "px";
          console.log("视频最适高度：" + this.realH);
          this.$forceUpdate();
        }, 200);
      }

      videoProcessInterval = setInterval(() => {
        this.changeProcess(video);
      }, 100);
    },
    pauseVideo() {
      //暂停\播放
      try {
        let video = document.querySelectorAll("video")[this.current];
        console.log("pauseVideo" + this.current);
        if (this.playOrPause) {
          video.pause();
          this.iconPlayShow = true;
          clearInterval(videoProcessInterval);
        } else {
          // wx.ready(() => {
          //     // 在微信的ready中进行播放 不管成功配置与否 都会执行ready
          //     video.play();
          // })
          video.play();
          video.pause();
          setTimeout(() => {
            video.play();
            this.iconPlayShow = false;
            videoProcessInterval = setInterval(() => {
              this.changeProcess(video);
            }, 100);
          }, 100);
        }
        this.playOrPause = !this.playOrPause;
        this.showShareBox = false;
      } catch (e) {
        alert(e);
      }
    },
    //记录播放进度
    changeProcess() {
      let video = document.querySelectorAll("video")[this.current];
      let currentTime = video.currentTime.toFixed(1);
      let duration = video.duration.toFixed(1);
      this.videoProcess = parseInt((currentTime / duration).toFixed(2) * 100);
    },
    onPlayerEnded(player) {
      //视频结束
      this.isVideoShow = true;
      this.current += this.current;
    },
    bianchengmy() {
      window.location.href = "/video/index?id=" + this.video_id;
    },
    // 分享
    setOpenShare(cont) {
      var that = this;
      if (isWeixin()) {
        getShare().then(res => {
          var data = res.data.data;
          var configAppMessage = {
            desc: "视频集，快乐的源泉",
            title: cont.video_name,
            link: location.href,
            imgUrl: cont.video_cover
          };
          openShareAll(configAppMessage);
        });
      }
    }
  }
};
</script>
<style scoped>
.dialog {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 9999;
}
.dialog img {
  display: block;
  width: 70%;
  margin-left: 26%;
}
.addimg {
  width: 100%;
  padding: 0.2rem 0.3rem;
  display: flex;
  position: relative;
  align-items: center;
}
.addimgs {
  position: relative;
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 0.12rem;
  overflow: hidden;
  margin-right: 0.2rem;
}
.addimgs img {
  display: block;
  width: 100%;
  height: 100%;
}
.addimgs input {
  display: block;
  width: 100%;
  height: 100%;
  opacity: 0;
  position: absolute;
  left: 0;
  right: 0;
}
.addimg .gg_text {
  /* font-size: 0.26rem; */
  width: calc(100% - 2.5rem);
  position: relative;
}
.footer_gg {
  /*  position: absolute;
  bottom: 0;
  left: 0; */
  background: #fff;
}
.gg_textTitle {
  font-size: 0.3rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.gg_textDec {
  font-size: 0.26rem;
  margin-top: 0.2rem;
  overflow: hidden;

  display: -webkit-box;

  -webkit-box-orient: vertical;

  -webkit-line-clamp: 2;
}
.clear {
  clear: both;
}

.back_i {
  position: fixed;
  top: 20px;
  left: 10px;
  width: 28px;
  z-index: 10;
}

.video-player {
  height: 100vh;
  width: 100vw;
}

.product_swiper {
  width: 100vw;
  height: 100vh;
}
span.editGg {
  background-image: linear-gradient(#fe8441, #ff4d19);
  color: #fff;
  font-size: 0.24rem;
  display: block;
  width: 0.8rem;
  text-align: center;
  line-height: 0.6rem;
  border-radius: 0.12rem;
}
.van_swipe {
  width: 100vw;
  height: 100vh;
  max-width: 550px;
  margin: 0 auto;
  position: relative;
}

.van-swipe {
  width: 100%;
  height: 100%;
}
.video_container {
  height: calc(100vh - 2rem);
  position: relative;
  overflow: hidden;
}
.container_box {
  width: 100vw;
  height: 100vh;
  background: #000;
}

.video_box {
  /* max-height: 100%; */
  width: 100%;
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform: translateY(-50%);
  transform: translate(-50%, -50%);
}

video {
  object-position: 0 0;
}

.icon_play {
  position: absolute;
  top: 44%;
  right: 0;
  left: 0;
  bottom: auto;
  margin: auto;
  z-index: 999;
  height: 60px;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 50%;
}

.play,
.platStart {
  position: absolute;
  margin: auto;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  height: 100%;
}

/*头像， 点赞，转发 */
.tag_image {
  width: 0.8rem !important;
  height: 0.8rem;
  border: 1px solid #fff;
  box-sizing: border-box;
  border-radius: 50%;
  margin-bottom: 20px;
  position: relative;
  box-shadow: 0px 0px 10px #9d9d9d;
}

.tag_add {
  z-index: 1;
  position: absolute;
  left: 0;
  right: 0;
  display: inline-block;
  margin: 0 auto;
  width: 0.3rem;
  height: 0.3rem;
  bottom: -0.06rem;
  border-radius: 100%;
  background-image: url(https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/yz_jia.png);
  background-color: #fff;
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: cover;
}

.tag_dui {
  position: absolute;
  bottom: 12px;
  left: 0;
  right: 0;
  border-radius: 67px;
  display: inline-block;
  width: 20px;
  height: 20px;
  line-height: 20px;
  margin: 0 auto;
  z-index: 1;
  font-size: 11px;
  color: #f44;
  background: #fff;
}

.tag_dui_active {
  opacity: 0;
  animation: showFollow 1.4s ease-in-out 0s;
}

.tag_add_num {
  position: absolute;
  bottom: 0px;
  left: 0;
  right: 0;
}

@keyframes showFollow {
  0% {
    opacity: 1;
    color: #fff;
    background: #f44;
    transform: rotate(-180deg) scale(1);
  }
  35% {
    opacity: 1;
    color: #f44;
    background: #fff;
    transform: rotate(0deg) scale(1.2);
  }
  80% {
    opacity: 1;
    color: #f44;
    transform: scale(1.2);
  }
  100% {
    opacity: 0;
    display: none;
    color: #f44;
    transform: scale(0);
  }
}

.tools_right {
  z-index: 1001;
  position: absolute;
  right: 16px;
  bottom: 180px;
}

.tools_r_li {
  margin-bottom: 20px;
  color: #fff;
  font-size: 0.22rem;
  position: relative;
  text-align: center;
}
.tools_r_li > img {
  width: 0.5rem;
  margin: 0 auto;
}
.tools_r_li:last-child {
  margin-bottom: 0px;
}

.icon_right {
  margin-bottom: 5px;
  font-size: 42px;
  display: block;
  text-shadow: 0px 0px 10px #9d9d9d;
  /*transition: .5s;*/
}

.production_box {
  z-index: 1001;
  position: absolute;
  bottom: 2rem;
  text-align: left;
  padding: 0 15px 0 15px;
  color: #fff;
  width: 100%;
  left: 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  background: -webkit-gradient(
    linear,
    left bottom,
    left top,
    from(rgba(0, 0, 0, 0.4)),
    to(transparent)
  );
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.4), transparent);
}

.production_name {
  font-weight: 700;
  font-size: 0.3rem;
  margin-bottom: 0.15rem;
}

.production_des {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  min-height: 0.6rem;
  font-size: 0.22rem;
}
.bianchengmy {
  width: 28%;
  margin: 0 auto;
  background: #ff4d19;
  border: 0.16rem;
  line-height: 0.8rem;
  text-align: center;
  position: fixed;
  right: 0;
  bottom: 1.5rem;
  color: #fff;
  border-radius: 0.4rem 0 0 0.4rem;
}
</style>
